//File to create a new project or update project data
import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, MenuItem, Typography, ListItemText, Checkbox, Select, TextField, Menu, IconButton, Autocomplete } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import axios from 'axios';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setSelectedProjectTitle } from '../../store/dailylog/Reducer';
import { BASEURL, ARROW, ConfirmationDialog, AUTOFILL_STYLES } from "../../constants/Common"
import getTheme from '../../theme/theme';
import { ThemeProvider } from '@mui/material';
import { Backdrop, CircularProgress, } from "@mui/material";
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export interface Projects {
  changeFlag: number;
  id: number | null;
  organization_id: string;
  created_by: string;
  project_name: string;
  project_code: string;
  created_on: string;
  project_type: string;
  project_status: string;
  project_start_date: string;
  project_end_date: string;
  project_manager: string;
  employees: string;
  contractors: string;
}
const CreateProjectPage = ({ onUpdateProjectList }: { onUpdateProjectList: (id: string, project_name: string) => void }) => {
  const defaultType = ['Residential', 'Commercial', 'Offices'];
  const defaultStatus = ['Pending', 'Started', 'In Progress', 'Completed']
  const [defaultManager, setDefaultManager] = useState([]);
  const [project_name, setProjectName] = useState('');
  const [project_manager, setProjectManager] = useState<string[]>([]);
  const [project_type, setType] = useState('');
  const [project_code, setProjectCode] = useState('');
  const [project_status, setStatus] = useState('');
  const [project_start_date, setStartDate] = useState('');
  const [project_end_date, setEndDate] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = getTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState('');
  const [empNames, setEmpNames] = useState<string[]>([]);
  const [contractorNames, setContractorNames] = useState<string[]>([]);
  const [selectedEmployees, setSelectedEmployees] = useState<string[]>([]);
  const [selectedContractors, setSelectedContractors] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState(false);


  const editProjectDetails = location?.state?.data;
  const orgid = localStorage.getItem('orgid');
  const username = localStorage.getItem('username');
  const userraccess = JSON.parse('' + localStorage.getItem('userrole'));
  const scheduleAccess = userraccess?.projectaccess;

  useEffect(() => {
    fetchDefaultProjectManager();
    fetch_emp_contracts_names();

    if (editProjectDetails) {
      const { project_manager, employees, contractors } = editProjectDetails;

      // setProjectManager(
      //   typeof project_manager === 'string' ? project_manager.split(',') : project_manager
      // );
      setProjectManager(
        typeof project_manager === 'string'
          ? project_manager.split(',').filter((name) => name.trim() !== '')
          : project_manager
      );
      setSelectedEmployees(
        typeof employees === 'string' ? employees.split(',') : employees
      );
      setSelectedContractors(
        typeof contractors === 'string' ? contractors.split(',') : contractors
      );
    }
  }, [editProjectDetails]);

  const fetch_emp_contracts_names = async () => {
    //To fetch employees, contractors list from users table

    try {
      //    const status_url = BASEURL + '/users/emp_contractor_list'
      const status_url = `${BASEURL}/users/emp_contractor_list?orgid=${orgid}`
      const response = await axios.get(status_url, {
        headers: { Accept: 'application/json', },
      });

      const { employees, contractors } = response.data;
      // Extract usernames
      const employeeUsernames = employees.map((emp: { username: any }) => emp.username);
      const contractorUsernames = contractors.map((con: { username: any }) => con.username);

      setEmpNames(employeeUsernames);
      setContractorNames(contractorUsernames);

    } catch (error) {
      console.log(error);
    }
  };


  const fetchDefaultProjectManager = async () => {
    //To fetch project manager list from users table

    try {
      //const status_url = BASEURL + '/users/pmlist'
      const status_url = `${BASEURL}/users/pmlist?orgid=${orgid}`

      const response = await axios.get(status_url, {
        headers: { Accept: 'application/json', },
      });

      const project_stat = response.data.projectmanager_names;
      const userNames = project_stat.map((manager: { username: string }) => manager.username);

      setDefaultManager(userNames);

    } catch (error) {
      console.log(error);
    }
  };

  const handleProjectName = (evt: any) => {
    setProjectName(evt.target.value)

  }

  const handleProjectManager = (event: SelectChangeEvent<typeof project_manager>) => {
    const { target: { value }, } = event;
    setProjectManager(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleProjectCode = (evt: any) => {
    setProjectCode(evt.target.value)
  }
  const handleProjectType = (evt: any) => {
    setType(evt.target.value)
  }
  const handleStatus = (evt: any) => {
    setStatus(evt.target.value)
  }
  const handleStartDate = (evt: any) => {
    setStartDate(evt.target.value)
  }
  const handleEndDate = (evt: any) => {
    setEndDate(evt.target.value)
  }

  function getTodayDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}-${month}-${date}`;
  }

  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because month is zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const validateInput = () => {
    //Validate the mandatory fields entered or not
    if (project_name.length === 0) {
      toast.error("Please enter project name.")
      return false;
    }

    /*
    if (project_manager.length === 0) {
      toast.error("Please enter project manager.")
      return false;
    }
    */

    if (project_start_date.length === 0) {
      toast.error("Please enter correct start date.")
      return false;
    }
    if (project_end_date.length === 0) {
      toast.error("Please enter correct end date.")
      return false;
    }

    if (!validateDateInput())
      return false
    return true;
  }

  const validateDateInput = () => {
    const startDateObj = new Date(project_start_date);
    const endDateObj = new Date(project_end_date);

    if (startDateObj >= endDateObj) {
      toast.error("Start date must be before the end date.")
      return false;
    }

    return true;
  }

  const handleCancel = (event: any) => {
    window.history.back();
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setIsSaving(true); // Disable save button

    let id = 0;
    if (editProjectDetails) {
      id = editProjectDetails.id;

      setIsLoading(true);

      let ret_input = validateDateInput();
      if (!ret_input) {
        setIsSaving(false); // Re-enable save button if validation fails
        return;
      }

      const payload = {
        changeFlag: 2,
        id: id,
        organization_id: orgid,
        created_by: editProjectDetails.created_by,
        project_name: project_name || editProjectDetails.project_name,
        project_code: project_code || editProjectDetails.project_code,
        project_manager: project_manager ? project_manager.join(',') : editProjectDetails?.project_manager,
        project_type: project_type || editProjectDetails?.project_type,
        project_status: project_status || editProjectDetails?.project_status,
        project_start_date: project_start_date || editProjectDetails?.project_start_date,
        project_end_date: project_end_date || editProjectDetails?.project_end_date,
        employees: selectedEmployees.join(','),
        contractors: selectedContractors.join(','),
      };

      await createNewProject(payload);
    } else {
      let ret_input = validateInput();
      if (!ret_input) {
        setIsSaving(false); // Re-enable save button if validation fails
        return;
      }

      const payload = {
        changeFlag: 1,
        id: id,
        organization_id: orgid,
        created_by: username,
        project_name: project_name,
        project_code: project_code,
        created_on: getTodayDate(),
        project_manager: project_manager.join(','),
        project_type: project_type.length === 0 ? defaultType[0] : project_type,
        project_status: project_status.length === 0 ? defaultStatus[0] : project_status,
        project_start_date: project_start_date,
        project_end_date: project_end_date,
        employees: selectedEmployees.join(','),
        contractors: selectedContractors.join(','),
      };

      await createNewProject(payload);
    }

    setIsLoading(false);
    setIsSaving(false); // Re-enable save button after completion
  };


  const createNewProject = async (payload: any) => {

    //Call post method to create/update project and on success display Proj mgmt screen with new data
    try {
      const create_url = BASEURL + '/projects/create/';
      let response = await axios.post(create_url, payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response?.status === 200) {
        toast.success(response?.data?.message);

        if (payload.id === 0) {
          payload.id = response?.data.project_id;
          dispatch(setSelectedProjectTitle(payload.id)); // Update selected project id  in Redux
          onUpdateProjectList(payload.id, payload.project_name);
        }

        navigate('/projmgmt', { state: { data: payload } });
        if (payload.project_status === 'Completed') {
          window.location.reload();
        }
      }

    } catch (error) {
      console.log(error);
    }
    finally {
      setIsSaving(false); // Ensure save button is re-enabled in case of error
    }
  };

  const handleDialogOpen = (type: any) => {
    setDialogType(type);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteProject = async () => {
    setOpenDialog(false);
    try {
      await axios.get(`${BASEURL}/projects/delete/${editProjectDetails.id}/`, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Project deleted successfully.');
      navigate('/projmgmt');
      window.location.reload();
    } catch (error) {
      console.error('Error deleting project', error);
    }
  };

  const handleConfirmSave = (event: any) => {
    setOpenDialog(false);
    handleSubmit(event);
  };

  const handleSaveProject = (event: any) => {
    event.preventDefault(); // Prevent the form from submitting immediately

    if (project_status === 'Completed') {
      // Open the confirmation dialog for saving
      handleDialogOpen('save');
    } else {
      // If status is not "Completed", proceed with saving
      handleSubmit(event);
    }
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>

      <div>

        {/* -----------------Project create/edit screen display starts  ---------------- */}

        <Box sx={{ marginTop: '-90px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            {/*
          {editProjectDetails ? (
            <h2>Project Management - Edit project details</h2>) : (
            <h2>Project Management - Create new project</h2>
          )}
        */}

            <Typography variant='h6' gutterBottom>
              {editProjectDetails ? (
                <span> <Link to="/projmgmt">Project Management </Link>{ARROW} Edit project details  </span>) : (
                <span> <Link to="/projmgmt">Project Management </Link>{ARROW} Create new project    </span>
              )}
            </Typography>
            {editProjectDetails && (
              <Box sx={{ marginLeft: 'auto' }}>
                <IconButton
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  // sx={{ marginRight: '30px' }}
                  sx={{ marginRight: '30px',
                    opacity: scheduleAccess !== 'Owner' ? 0.5 : 1
                   }}
                  disabled={scheduleAccess !== 'Owner'}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                >
                  <MenuItem onClick={handleDialogOpen}>Delete</MenuItem>
                </Menu>
              </Box>
            )}
          </Box>

          <form onSubmit={handleSubmit}>
            <Grid mt={1} container spacing={2}>
              <>
                <Grid item md={5} xs={12}>
                  <label htmlFor="project_name">Project Name:</label>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Grid item md={4} xs={12}>
                    <TextField defaultValue={editProjectDetails?.project_name}
                      onChange={(event) => handleProjectName(event)}
                      fullWidth variant="outlined" name="project_name"
                      sx={{
                        textAlign: "center", textJustify: "center",
                        width: { sm: 200, md: 350 }, "& .MuiInputBase-root": { height: 40 },
                        ...AUTOFILL_STYLES(theme)
                      }} />
                  </Grid>
                </Grid>


                <Grid item md={5} xs={12}>
                  <label htmlFor="project_code">Project Code:</label>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Grid item md={4} xs={12}>
                    <TextField defaultValue={editProjectDetails?.project_code}
                      onChange={(event) => handleProjectCode(event)}
                      fullWidth variant="outlined" name="project_code"
                      sx={{
                        textAlign: "center", textJustify: "center",
                        width: { sm: 200, md: 350 }, "& .MuiInputBase-root": { height: 40 },
                        ...AUTOFILL_STYLES(theme)
                      }} />
                  </Grid>
                </Grid>


                <Grid item md={5} xs={12}>
                  <label htmlFor="project_manager">Project Manager:</label>
                </Grid>
                <Grid item md={7} xs={12}>


                  <Select
                    id="multiple-checkbox"
                    multiple
                    value={project_manager}
                    onChange={(event) => handleProjectManager(event)}
                    renderValue={(selected) => selected.join(', ')}
                    sx={{
                      width: "100%", maxWidth: '350px',
                      height: 40, // Set the height of the dropdown box to 40px
                      // "& .MuiSelect-root": { 
                      //   minHeight: 40,
                      //   color: 'black', // Set the color of the select box text
                      //   '&:focus': {
                      //     backgroundColor: 'transparent', // Set the background color when focused
                      //   },
                      // },
                      // "& .MuiInputBase-root": { 
                      //   height: 40, 
                      //   '&.Mui-focused': {
                      //     backgroundColor: 'transparent', // Set the background color when focused
                      //   },
                      // },
                      // "& .MuiMenuItem-root.Mui-selected": {
                      //   color: 'black', // Set the color of the selected option text
                      //   backgroundColor: 'transparent', // Set the background color of the selected option
                      // },
                      // '& .MuiOutlinedInput-notchedOutline': {
                      //   borderColor: 'black', // Set the border color of the outlined input
                      // },
                      // '& .MuiSelect-icon': {
                      //   color: 'black', // Set the color of the dropdown icon
                      // },
                    }}
                  >


                    {defaultManager.length === 0 ? (
                      <MenuItem disabled
                        sx={{
                          fontStyle: 'italic', // Italic text
                        }}>
                        <ListItemText primary="No users with Project Manager role" />
                      </MenuItem>
                    ) : (
                      defaultManager.map((name) => (
                        <MenuItem key={name} value={name}>
                          <Checkbox checked={project_manager.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  <Typography
                    variant="body2"
                    sx={{
                      marginTop: 1,
                      color: 'grey.500', // Grey color from theme
                      fontStyle: 'italic', // Italic text
                    }}
                  >
                    *Only users with Project Manager role
                  </Typography>
                </Grid>


                <Grid item md={5} xs={12}>
                  <label htmlFor="project_type">Project Type:</label>
                </Grid>
                <Grid item md={6} xs={12}>


                  <Select
                    defaultValue={editProjectDetails?.project_type || defaultType[0]}
                    onChange={(event) => handleProjectType(event)}
                    fullWidth variant="outlined"
                    name="project_type"
                    sx={{
                      width: "100%", maxWidth: '350px',
                      height: 40, // Set the height of the dropdown box to 40px
                      // "& .MuiSelect-root": { 
                      //   minHeight: 40,
                      //   color: 'black', // Set the color of the select box text
                      //   '&:focus': {
                      //     backgroundColor: 'transparent', // Set the background color when focused
                      //   },
                      // },
                      // "& .MuiInputBase-root": { 
                      //   height: 40, 
                      //   '&.Mui-focused': {
                      //     backgroundColor: 'transparent', // Set the background color when focused
                      //   },
                      // },
                      // "& .MuiMenuItem-root.Mui-selected": {
                      //   color: 'black', // Set the color of the selected option text
                      //   backgroundColor: 'transparent', // Set the background color of the selected option
                      // },
                      // '& .MuiOutlinedInput-notchedOutline': {
                      //   borderColor: 'black', // Set the border color of the outlined input
                      // },
                      // '& .MuiSelect-icon': {
                      //   color: 'black', // Set the color of the dropdown icon
                      // },
                    }}
                  >
                    {defaultType.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>



                </Grid>


                <Grid item md={5} xs={12}>
                  <label htmlFor="project_status">Project Status:</label>
                </Grid>
                <Grid item md={6} xs={12}>


                  <Select
                    defaultValue={editProjectDetails?.project_status || defaultStatus[0]}
                    onChange={(event) => handleStatus(event)}
                    fullWidth variant="outlined"
                    name="project_status"
                    sx={{
                      width: "100%", maxWidth: '350px',
                      height: 40, // Set the height of the dropdown box to 40px
                      // "& .MuiSelect-root": { 
                      //   minHeight: 40,
                      //   color: 'black', // Set the color of the select box text
                      //   '&:focus': {
                      //     backgroundColor: 'transparent', // Set the background color when focused
                      //   },
                      // },
                      // "& .MuiInputBase-root": { 
                      //   height: 40, 
                      //   '&.Mui-focused': {
                      //     backgroundColor: 'transparent', // Set the background color when focused
                      //   },
                      // },
                      // "& .MuiMenuItem-root.Mui-selected": {
                      //   color: 'black', // Set the color of the selected option text
                      //   backgroundColor: 'transparent', // Set the background color of the selected option
                      // },
                      // '& .MuiOutlinedInput-notchedOutline': {
                      //   borderColor: 'black', // Set the border color of the outlined input
                      // },
                      // '& .MuiSelect-icon': {
                      //   color: 'black', // Set the color of the dropdown icon
                      // },
                    }}  >

                    {defaultStatus.map((status, index) => (
                      <MenuItem key={index} value={status}>
                        {status}
                      </MenuItem>
                    ))}

                  </Select>
                </Grid>


                <Grid item md={5} xs={12}>
                  <label htmlFor="project_start_date">Project Start Date:</label>
                </Grid>
                <Grid item md={6} xs={12}>
                  <>
                    <Grid item md={4} xs={12}>
                      <TextField defaultValue={editProjectDetails?.project_start_date} type="date" onChange={(event) => handleStartDate(event)}
                        fullWidth variant="outlined" name="project_start_date"
                        sx={{
                          textAlign: "center", textJustify: "center",
                          width: { sm: 200, md: 350 },
                          "& .MuiInputBase-root": { height: 40 }
                        }} />
                    </Grid>
                  </>
                </Grid>

                <Grid item md={5} xs={12}>
                  <label htmlFor="project_end_date">Project End Date:</label>
                </Grid>
                <Grid item md={6} xs={12}>
                  <>
                    <Grid item md={4} xs={12}>
                      <TextField defaultValue={editProjectDetails?.project_end_date} type="date" onChange={(event) => handleEndDate(event)}
                        fullWidth variant="outlined" name="project_end_date"
                        sx={{
                          textAlign: "center", textJustify: "center",
                          width: { sm: 200, md: 350 },
                          "& .MuiInputBase-root": { height: 40 }
                        }} />
                    </Grid>
                  </>
                </Grid>

                {/* Employees */}
                <Grid item md={5} xs={12} sx={{ marginTop: '20px' }}>
                  <label htmlFor="employees">Assigned Employees:</label>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    multiple
                    options={empNames}
                    value={selectedEmployees}
                    onChange={(event, newValue) => {
                      const validEmployees = newValue.filter(emp => emp.trim() !== "");
                      setSelectedEmployees(validEmployees);
                    }}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 1 }}
                        />
                        {option}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={
                          selectedEmployees.length === 0 || selectedEmployees.every(emp => emp.trim() === "")
                            ? "Select Employees"
                            : `${selectedEmployees.length} employee${selectedEmployees.length > 1 ? 's' : ''} assigned`
                        }
                      />
                    )}
                    renderTags={() => null} // Hide default tags
                    sx={{ maxWidth: '350px', mb: '20px', '& .MuiAutocomplete-popover': { maxHeight: '150px', overflowY: 'auto' } }}
                  />
                </Grid>

                {/* Contractors */}
                <Grid item md={5} xs={12} sx={{ marginTop: '20px' }}>
                  <label htmlFor="contractors">Assigned Contractors:</label>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    multiple
                    options={contractorNames}
                    value={selectedContractors}
                    onChange={(event, newValue) => {
                      // Filter out empty strings or invalid entries
                      const validContractors = newValue.filter(contractor => contractor.trim() !== "");
                      setSelectedContractors(validContractors);
                    }}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 1 }}
                        />
                        {option}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={
                          selectedContractors.length === 0 || selectedContractors.every(contractor => contractor.trim() === "")
                            ? "Select Contractors"
                            : `${selectedContractors.length} contractor${selectedContractors.length > 1 ? 's' : ''} assigned`
                        }
                      />
                    )}
                    renderTags={() => null} // Hide default tags
                    sx={{ maxWidth: '350px', '& .MuiAutocomplete-popover': { maxHeight: '150px', overflowY: 'auto' } }}
                  />
                </Grid>

              </>
            </Grid>


            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveProject}
                sx = {{'&:disabled': { bgcolor: 'grey.400', color: 'grey.700' }}}
                disabled={isSaving}
              >
                Save
              </Button>
              <Button onClick={handleCancel} variant='contained' color='primary'>
                Cancel
              </Button>

            </Box>
            <ConfirmationDialog
              open={openDialog}
              handleClose={handleDialogClose}
              handleConfirm={dialogType === 'save' ? handleConfirmSave : handleDeleteProject}
              message={
                dialogType === 'save'
                  ? 'Mark this project as completed? It will be hidden from header. Contact support to restore.'
                  : 'Are you sure you want to delete this project? This action is irreversible.'
              }
              title={dialogType === 'save' ? 'Confirm Completion' : 'Confirm Deletion'}
            />
          </form>
        </Box>

        {/*----------------------------*/}
        <FloatingButton />
      </div>
    </ThemeProvider >

  );
};

export default CreateProjectPage;
